interface ITextareaProps {
  name: string;
  size?: 'small' | 'medium' | 'large' | 'custom';
  defaultValue?: string;
  className?: string;
}

export const TextareaBasic = ({ name, size = 'large', defaultValue = '', className = '' }: ITextareaProps) => (
  <textarea
    name={name}
    placeholder="Type here..."
    defaultValue={defaultValue}
    className={`${className} ${size === 'custom' ? '' : size === 'large' ? 'h-60' : size === 'medium' ? 'h-40' : 'h-20'} w-full px-4 py-[10px] bg-gray-800 rounded scrollbar-none resize-none`}
  ></textarea>
);
